import { defineStore } from "pinia";
import { instance } from "..";

export const store = defineStore({
  id: "chat",
  state: () => ({
    open: false,
  }),
  actions: {
    setOpen(value: boolean) {
      this.open = value;
    },
  },
});

export const useChatStore = store(instance);
